import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

/**
 * @param root0
 * @param root0.title
 * @param root0.icon
 * @param root0.span
 * @param root0.variant
 * @param root0.headerExtra
 * @param root0.headerSub
 * @param root0.bottomActions
 * @param root0.className
 * @param root0.addContentGutter
 * @param root0.lightTheme
 * @param root0.children
 */
const GlassCard = ({
  title,
  icon,
  span = 12,
  variant = 'default',
  headerExtra,
  headerSub,
  bottomActions,
  className,
  addContentGutter = false,
  lightTheme = false,
  children,
}) => {
  const hasBottomActions = bottomActions !== null;

  return (
    <div
      className={clsx(
        'glass-card',
        `glass-card--span-${span}`,
        {
          'glass-card--focus': variant === 'focus',
          'glass-card--accent': variant === 'accent',
          'glass-card--light': lightTheme,
        },
        className,
      )}
    >
      {(title ?? icon ?? headerExtra) && (
        <div className="glass-card__header">
          <div className="glass-card__header-left">
            {icon && <FontAwesomeIcon icon={icon} className="glass-card__icon" />}
            {title && <h3 className="glass-card__title">{title}</h3>}
          </div>
          {headerExtra && <div className="glass-card__header-right">{headerExtra}</div>}
        </div>
      )}
      {headerSub && <div className="glass-card__header-sub">{headerSub}</div>}
      <div
        className={clsx('glass-card__content', {
          'glass-card__content--gutter': addContentGutter,
        })}
      >
        {children}
      </div>
      {hasBottomActions && <div className="glass-card__bottom-actions">{bottomActions}</div>}
    </div>
  );
};

export default GlassCard;
